import React from 'react'
import { Link } from 'react-router-dom'
import appRoutes from '../routes/routeConfig'

const Unauthorized = () => {
      return (
        <div className="account-body accountbg">
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-5 mx-auto">
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <Link to={appRoutes.root} className="logo logo-admin mt-05">
                                                <img src="/assets/images/logo-sm.png" height="50" alt="logo" className="auth-logo" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="ex-page-content text-center">
                                            <img src="/assets/images/error.svg" alt="0" className="" height="170" />
                                            <h1 className="font-24 mt-2 mb-0">Unauthorized!</h1>  
                                            <p className="font-16 text-muted mb-2">You do not have permission to access this resource. Contact Admin</p>                                    
                                        </div>          
                                        <Link className="btn btn-primary btn-block waves-effect waves-light" to={appRoutes.root}>Back Home <i className="fas fa-home ml-1"></i></Link>                         
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Central Bank of Nigeria &copy; {new Date().getFullYear()}</span>                                              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Unauthorized